module.exports = __webpack_public_path__ + "img/nr.d5f8a85e.svg";